import { Button, Dialog, Divider, Grid, MenuItem, Stack, Typography } from "@mui/material";
import useStorefrontStore from "../../../stores/public/useStorefrontStore";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import getAvailability from "../../../api/auth/items/getAvailability";
import { addDays, addMonths, endOfMonth, format, isPast, startOfMonth } from "date-fns";
import Calendar from "@demark-pro/react-booking-calendar";
import PageLoading from "../../../components/layout/PageLoading";
import WushTextField from "../../../components/form/WushTextField";
import { useForm } from "react-hook-form";
import index from "../../../api/auth/items/itemBookableDurations";
import useCheckoutStore from "../../../stores/public/useCheckoutStore";
import create from "../../../api/public/storefronts/reservations/create";
import update from "../../../api/public/storefronts/reservations/update";
import toCurrency from "../../../services/toCurrency";
import useAlertStore from "../../../stores/useAlertStore";
import { ShoppingCart } from "@mui/icons-material";
import getAvailableTimes from "../../../api/auth/items/getAvailableTimes";
import WushCard from "../../../components/layout/WushCard";
import StorefrontHome from "./StorefrontHome";
import { formatPhoneNumber } from "../../../components/displays/storeFront/checkout/CheckoutWizard";

export default function Item() {
  const { id } = useParams();
  const { itemById, organization } = useStorefrontStore();
  const { reservation, addReservation, updateReservation, setReservations, reservations, setOrder, order } = useCheckoutStore();
  const [ selectedDate, setSelectedDate ] = useState(null);
  const [ selectedEndDate, setSelectedEndDate ] = useState(null);
  const [ selectedHour, setSelectedHour ] = useState(null);
  const [ selectedQuantity, setSelectedQuantity ] = useState(1);
  const [ selectedBookableDuration, setSelectedBookableDuration ] = useState(null);
  const [ addedToCart, setAddedToCart ] = useState();
  const [ showCalendar, setShowCalendar ] = useState(false);
  const [ showAvailabilities, setShowAvailabilities ] = useState(false);
  const [ showTimeSelect, setShowTimeSelect ] = useState(false);

  const [ startDate, setStartDate ] = useState(startOfMonth(new Date()));
  const [ endDate, setEndDate ] = useState(endOfMonth(addMonths(new Date(), 1)));
  const [ activeMonth, setActiveMonth ] = useState(new Date().getMonth());
  const [ availability, setAvailability ] = useState(null);
  const [ hourAvailability, setHourAvailability ] = useState([]);
  const [ bookableDurations, setBookableDurations ] = useState([]);

  const showInventoryLevels = organization.storefront_display_inventory_quantities;

  const { register, handleSubmit, watch, formState: { isDirty } } = useForm();

  const { setAlertMessage } = useAlertStore();

  const navigate = useNavigate();

  const item = itemById(id);

  const addDateTime = (date, time, days) => {
    let dateString = date;
    if(dateString?.length > 12) dateString = format(new Date(date), 'yyyy-MM-dd');
    const timeString = format(new Date(time), 'HH:mm:ss');
    let addedDate = new Date(`${dateString}T${timeString}`);
    addedDate = addDays(addedDate, days);
    console.log("line28", addedDate);
    return addedDate;
  };

  useEffect(() => {
    getAvailability(id, startDate, endDate, (response) => {
      setAvailability(response);
    });
  }, [id, activeMonth]);

  useEffect(() => {
    index(id, (response) => {
      setBookableDurations(response);
    });
  }, [id]);

  useEffect(() => {
    if(!watch('bookable_duration_id') || !selectedDate) return;
    const bookableDuration = bookableDurations.find((bookableDuration) => bookableDuration.bookable_duration_id === watch('bookable_duration_id'));

    if(bookableDuration.bookable_duration.duration_type === 'hourly') {
      getAvailableTimes(id, selectedDate, bookableDuration.bookable_duration.id, (response) => {
        setHourAvailability(response);
        setShowTimeSelect(true);
      });
    }
  }, [selectedDate, watch('bookable_duration_id')]);

  useEffect(() => {
    if(!watch('bookable_duration_id')) return;
    const bookableDuration = bookableDurations.find((bookableDuration) => bookableDuration.bookable_duration_id === watch('bookable_duration_id'));

    if(!bookableDuration?.default_available && bookableDuration?.item_availabilities.length > 0) {
      const firstAvailability = bookableDuration?.item_availabilities[0];
      setSelectedDate(new Date(firstAvailability.start_at));
      setStartDate(startOfMonth(new Date(firstAvailability.start_at)));
      setEndDate(endOfMonth(new Date(firstAvailability.start_at)));
    } else {
      setShowAvailabilities(true);
    }
    setShowCalendar(true);
  }, [id, watch('bookable_duration_id')]);

  useEffect(() => {
    const bookableDuration = bookableDurations.find((bookableDuration) => bookableDuration.bookable_duration_id === watch('bookable_duration_id'));
    setSelectedBookableDuration(bookableDuration);
    if(selectedDate && bookableDuration?.bookable_duration?.duration_type === 'full_day') {
      setSelectedEndDate(addDateTime(format(selectedDate, 'yyyy-MM-dd'), bookableDuration?.bookable_duration?.end_time, bookableDuration?.bookable_duration?.days - 1));
    }
  }, [watch('bookable_duration_id')]);

  const onSubmit = (data) => {
    if(reservation?.id) {
      update(organization.id, reservation.id, {
        reservation_items: [
          {
            item_id: item.id,
            quantity: data.quantity
          }
        ],
        start_at: selectedDate,
        end_at: addDays(selectedDate, 2),
        bookable_duration_id: data.bookable_duration_id
      }, (reservationResponse) => {
        if(!reservationResponse.error) {
          updateReservation(reservationResponse);
          setOrder(reservationResponse.order);
          setShowTimeSelect(false);
          setAddedToCart(true);
        } else {
          setAlertMessage(reservationResponse.error, 'error');
        }
      }, () => {
        setOrder(null);
        setReservations([]);
        setAlertMessage('Cart expired please try again', 'error');
      });
    } else {
      create(organization.id, {
        reservation_items: [
          {
            item_id: item.id,
            quantity: data.quantity
          }
        ],
        start_at: selectedDate,
        end_at: addDays(selectedDate, 2),
        bookable_duration_id: data.bookable_duration_id,
        order_id: order?.id
      }, (reservationResponse) => {
        if(!reservationResponse.error) {
          addReservation(reservationResponse);
          setOrder(reservationResponse.order);
          setShowTimeSelect(false);
          setAddedToCart(true);
        } else {
          setAlertMessage(reservationResponse.error, 'error');
        }
      }, () => {
        setOrder(null);
        setReservations([]);
        setAlertMessage('Cart expired please try again', 'error');
      });
    }
  };

  const displayInventoryAvailable = (date) => {
    const availabilityCount = availability[format(date, 'yyyy-MM-dd')];
    if(showInventoryLevels) {
      return availabilityCount > 0 ? `${availabilityCount} avail` : '0 avail';
    } else {
      return availabilityCount > 0 ? 'Available' : 'Unavailable';
    }
  };

  const handleDateSelect = (date) => {
    if(showAvailabilities) {
      setSelectedDate(date[0]);
      if(selectedBookableDuration?.bookable_duration?.duration_type === 'full_day') {
        setSelectedEndDate(addDateTime(format(date[0], 'yyyy-MM-dd'), selectedBookableDuration?.bookable_duration?.end_time, selectedBookableDuration?.bookable_duration?.days - 1), { shouldDirty: true });
      }
    }
  };

  const handleTimeSelect = (hour) => {
    setSelectedHour(hour);
    setSelectedDate(new Date(selectedDate.setHours(hour - new Date().getTimezoneOffset() / 60)));
  };

  if(!availability) return <PageLoading />;

  return (
    <Stack>
      <Grid container spacing={4}>
        <Grid item sm={5}>
          <Stack>
            <img src={item.image_url} width="100%" alt={item.name} />
          </Stack>
        </Grid>
        <Grid item sm={7}>
          <Stack>
            <Stack>
              <Typography variant="body2" fontWeight="700">{item.item_category.name}</Typography>
            </Stack>
            <Stack mb={2}>
              <Typography variant="h3">{item.name}</Typography>
            </Stack>
            <Stack
              sx={{
                'p': {
                  fontSize: "18px"
                }
              }}
            >
              <div dangerouslySetInnerHTML={{ __html: item.storefront_description }} />
            </Stack>
          </Stack>
          <Stack direction="row" gap={4} mb={2}>
            <Stack width="25%">
              <WushTextField
                formRegistration={register("quantity", { onChange: (e) => setSelectedQuantity(e.target.value)})}
                label="Quantity"
                defaultValue={1}
                type="number"
              />
            </Stack>
            <Stack width="75%">
              <WushTextField width="100%" formRegistration={register("bookable_duration_id")} label="Options" select>
                {bookableDurations.map((bookableDuration) => bookableDuration.active && (
                  <MenuItem key={bookableDuration.id} value={bookableDuration.bookable_duration.id}>
                    <Typography>{bookableDuration.bookable_duration.name} - {toCurrency(bookableDuration.price_dollars)}</Typography>
                  </MenuItem>
                ))}
              </WushTextField>
            </Stack>
          </Stack>
          {showCalendar && <Stack mb={2} spacing={1}>
            <Calendar
              startDate={startDate}
              endDate={endDate}
              onMonthChange={(month) => {
                const newStartDate = new Date(startDate.getFullYear(), month, 1);
                setStartDate(startDate);
                setEndDate(endOfMonth(addMonths(newStartDate, 1)));
                setActiveMonth(month);
              }}
              onChange={handleDateSelect}
              selected={[selectedDate, selectedEndDate]}
              disabled={(date) => isPast(date) || (selectedBookableDuration?.bookable_duration?.duration_type === 'full_day' && (!availability[format(date, 'yyyy-MM-dd')] || availability[format(date, 'yyyy-MM-dd')] < selectedQuantity))}
              variant="events"
              components={{
                DayCellFooter: (val) => !isPast(val.date) && selectedBookableDuration?.bookable_duration?.duration_type === 'full_day' && showAvailabilities && (
                  <Typography fontSize="8px">{displayInventoryAvailable(val.date)}</Typography>
                ),
              }}
            />
            {organization.support_phone && <Stack>
              <Typography variant="body1">
                Something unavailable or need help? Call us at {formatPhoneNumber(organization.support_phone)}
              </Typography>
            </Stack>}
          </Stack>}
          <Stack>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={4}>
                <Button
                  sx={{ width: "100%" }}
                  disabled={!selectedDate || !isDirty}
                  variant="contained"
                  type="submit"
                  onClick={handleSubmit(onSubmit)}
                >
                  Add to cart
                </Button>
              </Grid>
              <Grid item xs={12} sm={4}>
                {reservations.length > 0 && <Button
                  sx={{ width: "100%" }}
                  variant="outlined"
                  onClick={() => navigate('/checkout')}
                >
                  <Stack direction="row" spacing={2}>
                    <ShoppingCart />
                    <Typography>
                      Checkout
                    </Typography>
                  </Stack>
                </Button>}
              </Grid>
            </Grid>
          </Stack>
        </Grid>
      </Grid>
      <Stack my={2}>
        <Divider />
      </Stack>
      <Grid container>
        <Grid xs={12}>
          <StorefrontHome />
        </Grid>
      </Grid>
      <Dialog
        open={showTimeSelect}
        onClose={() => setShowTimeSelect(false)}
      >
        <Stack py={2} px={5}>
          {selectedDate && <Stack mb={2}>
            <Typography variant="h4">Select a time for {format(selectedDate, 'LLLL d, y')}</Typography>
          </Stack>}
          <Stack spacing={1} mb={2}>
            {Object.keys(hourAvailability).map((hour) => console.log(selectedQuantity) ||
              <WushCard
                key={hour}
                onClick={() => handleTimeSelect(hour)}
                bgcolor={hour === selectedHour ? 'primary.main' : 'background.default'}
                disabled={hourAvailability[hour] < selectedQuantity}
              >
                <Stack p={1}>
                  <Typography>{format(new Date().setHours(hour - new Date().getTimezoneOffset() / 60), 'h:00 aa')}</Typography>
                </Stack>
              </WushCard>)
            }
          </Stack>
          {selectedHour && <Stack direction="row">
            <Button
              sx={{ width: "100%" }}
              disabled={!selectedDate || !isDirty}
              variant="contained"
              type="submit"
              onClick={handleSubmit(onSubmit)}
            >
              Add to cart
            </Button>
          </Stack>}
        </Stack>
      </Dialog>
      <Dialog
        open={addedToCart}
        onClose={() => setAddedToCart(false)}
      >
        <Stack p={2} textAlign="center">
          <Stack justifyContent="center">
            <Typography variant="h4">Item added to cart!</Typography>
          </Stack>
          <Stack>

          </Stack>
          <Stack direction="row" mb={2}>
            <Typography variant="h6">Would you like to continue shopping or checkout?</Typography>
          </Stack>
          <Stack direction="column" gap={2} px="10%">
            <Button
              variant="contained"
              onClick={() => {
                setAddedToCart(false);
                navigate('/checkout');
              }}
            >
              Checkout
            </Button>
            <Button
              variant="outlined"
              onClick={() => setAddedToCart(false)}
            >
              Continue Shopping
            </Button>
          </Stack>
        </Stack>
      </Dialog>
    </Stack>
  );
}